import BaseModalView from "scripts/views/baseModalView";
import ChangePasswordFormView from "scripts/views/changePasswordFormView";

import templateChangePasswordModal from "templates/changePasswordModal.hbs";

class ChangePasswordModalView extends BaseModalView {
  constructor(options) {
    super(options);

    this.oldPassword = options && options.oldPassword;

    this.changePasswordFormView = this.addSubView(
      new ChangePasswordFormView({
        oldPassword: this.oldPassword,
        username: options && options.username,
        token: options && options.token,
      }),
    );

    this.changePasswordFormView.on(
      "success",
      this.onChangePasswordSuccess,
      this,
    );
    this.changePasswordFormView.on(
      "failure",
      this.onChangePasswordFailure,
      this,
    );
  }

  get template() {
    return templateChangePasswordModal;
  }

  render() {
    this.$el.html(
      this.template({
        oldPassword: this.oldPassword,
      }),
    );

    this.changePasswordFormView
      .appendTo(this.$el.find("#bb-change-password-form-region"))
      .render();

    return this;
  }

  onChangePasswordSuccess() {
    this.trigger("success", this);
    this.closeModal();
  }

  onChangePasswordFailure(error) {
    this.trigger("failure", error);
  }
}

export default ChangePasswordModalView;
